export default __webpack_public_path__ + "static/media/unknownModel.1e912aa2.png";